/**
 * UUID generation utility
 */

/**
 * Generate a unique ID for elements
 * Uses crypto.randomUUID if available, fallback to timestamp-based
 */
export function generateId(): string {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    // Fallback for older browsers
    return `${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
}
